<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>Product Cost History</h2>

    <div>
      @if (this.canRevalue()) {
        <button class='btn btn-secondary' routerLink='/warehousing/stock-revaluation'><i class="fas fa-balance-scale"></i> Revalue Stock</button>&nbsp;
      }
      <button class='btn btn-secondary' routerLink='/warehousing/stock-levels'><i class="fas fa-layer-group"></i> Stock Levels</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/dashboard'><i class="fas fa-tachometer-alt"></i> Dashboard</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/reports'><i class="fas fa-chart-line"></i> Reports</button>&nbsp;
    </div>
  </div>
  <br />

  <div class="alert alert-info">
    Every change to a product's buying price, and who made it. Written at the moment the cost changed,
    so it cannot be edited or removed from here. Correct a wrong entry by changing the cost again with
    an explanation, which leaves both entries standing.
    <br /><br />
    A cost is the price of the <strong>next</strong> intake. Changing it does not restate what stock
    already received is worth &mdash; to move the value of stock on hand, post a
    @if (this.canRevalue()) {
      <a routerLink='/warehousing/stock-revaluation'>revaluation</a>.
    } @else {
      revaluation, which your user is not granted.
    }
  </div>

  <!-- An empty audit table is a statement: it says nobody has ever changed a cost. When the real
       reason is that the route does not answer, that statement is false in the reassuring
       direction, so the screen distinguishes the two rather than painting an empty grid. -->
  @if (this.isUnavailable) {
    <div class="alert alert-warning">
      <strong>Cost history is not available on this server yet.</strong>
      The history route did not answer, so the table below is empty because nothing could be read
      &mdash; not because no cost has ever changed. Do not read an empty result here as evidence that
      prices have never been altered.
    </div>
  }

  @if (this.isForbidden) {
    <div class="alert alert-warning">
      <strong>You do not have permission to read cost history.</strong>
      Buying prices are commercially sensitive, so the audit trail is a separate right from the rest
      of warehousing. The table below is empty for that reason and not because no cost has changed.
    </div>
  }

  <div class="form-row">
    <div class="form-group col-md-4">
      <label>Product</label>
      <select class='form-control' (change)='this.onProductChanged($event.target.value)'>
        <option value='-1'>All products</option>
        @for (item of this.products; track item) {
          <option [value]='item.id' [selected]='this.selectedProductId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>

    @if (this.getSelectedProduct()) {
      <div class="form-group col-md-4">
        <label>Cost Today</label>
        <p class='form-control-plaintext'>
          <strong>{{ this.getSelectedProductCost() }}</strong>
        </p>
      </div>
    }
  </div>

  <!-- "Not priced" and "£0.00" are different answers and the screen says so out loud, because the
       likeliest misreading of this table is treating an unpriced product as one worth nothing. -->
  <!-- alert-warning, not alert-secondary. Bootstrap is not installed on this project - styles.scss is
       a hand-rolled subset - so `alert-secondary` matches nothing and inherits `.alert`'s
       `color: white`, which renders white text on a white box. Verified in headless chromium: the
       message was there in the DOM and completely unreadable. Only alert-info, alert-warning,
       alert-success and alert-danger exist. -->
  @if (this.isSelectedProductUnpriced()) {
    <div class="alert alert-warning">
      This product has <strong>never been given a cost</strong>. That is not the same as a cost of
      £0.00, which is a real price and is what 3PL stock the warehouse holds but does not own carries.
      Stock of an unpriced product cannot be valued at all, so it contributes nothing to a stock
      valuation and any total including it understates.
    </div>
  }

  <br />

  <app-grid
    [entity]='this.entity'
    [filters]='this.filters'
    [columns]='this.columns'
    [relationships]='this.relationships'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
    sortColumn='id'
    sortDirection='desc'
  ></app-grid>

  <p class='text-muted'>
    <strong>{{ this.getNotPricedLabel() }}</strong> in a cost column means no amount was recorded.
    A product priced deliberately at nothing shows as £0.00.
  </p>
</div>
